// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"bebcdec3","266":"0512de7a","379":"841609c1","380":"2a3d05d7","515":"1cab2203","606":"044746f3","626":"bebd4554","771":"4cdbc356","835":"ce32d70d","975":"fd85cc18","976":"46965a0a","977":"f1fdecad"}[chunkId] + ".chunk.js";
};